import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0020a351"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom_input_field" }
const _hoisted_2 = { class: "custom_input_field tw-pb-6 tw-rounded-none tw-border-[#C5D2F2] tw-border-0 tw-border-b tw-border-solid" }
const _hoisted_3 = { class: "tw-flex tw-gap-3" }

import GeneralDialog from "@/core/uni-components/GeneralDialog.vue";
import Button from "@/core/uni-components/Button.vue";
import Text from "@/core/uni-components/Text.vue";
import { ref } from "vue";
import { useStore } from "vuex";
import { computed } from "vue";
import { watch } from "vue";
import { AgreeTermsConsumerDisclosure } from "@/core/enums/estimateEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'RejectProjectEstimateModal',
  props: {
  projectId: Number,
  projectEstimateId: Number,
},
  emits: ["on-cancel", "on-confirm"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const selectedRejectTypes = ref(null);
const message = ref("");
const formValid = ref(false);
const rejectType = ref(1);
const onClickBackButton = () => {
  selectedRejectTypes.value = null;
  message.value = "";
};

const typeList = ref([
  // {
  //   label: "Routine Inspection",
  //   value: "routine_inspection",
  // },
  // {
  //   label: "Complaint Investigation",
  //   value: "complaint_investigation",
  // },
  // {
  //   label: "Follow-up Visit",
  //   value: "follow_up_visit",
  // },
  {
    label: "Estimate is too high",
    value: "estimate_is_too_high",
  },
  {
    label: "Not enough detail provided",
    value: "not_enough_detail_provided",
  },
  {
    label: "Timeline is too long",
    value: "timeline_is_too_long",
  },
  {
    label: "Project no longer required",
    value: "project_no_longer_required",
  },
  { label: "Others", value: "others" },
]);
const customReason = ref("");
const isCustomReason = computed(() => selectedRejectTypes.value === "others");

watch(selectedRejectTypes.value, (newValue) => {
  if (newValue !== "others") {
    customReason.value = "";
  }
});
const onCancelModal = () => {
  emits("on-cancel");
};

const props = __props;

const modalHeader = {
  title: "Reject Estimate",
};

const onConfirm = async () => {
  if (formValid.value) {
    const payload = {
      rejectionReason: isCustomReason.value
        ? customReason.value
        : selectedRejectTypes.value,
      rejectionMessage: message.value,
      deleteOption: rejectType.value,
    };

    emits("on-confirm", payload);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    headerTitle: modalHeader.title,
    class: "project_reject_estimate_modal",
    width: "570px",
    "max-width": "100%",
    onOnClose: onCancelModal,
    onOnBack: onClickBackButton
  }, {
    body: _withCtx(() => [
      _createVNode(Text, {
        variant: "h5",
        lineHeight: "28px",
        textWeight: "400"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Reject Estimate")
        ]),
        _: 1
      }),
      _createVNode(_component_v_form, {
        ref: "form",
        modelValue: formValid.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formValid).value = $event)),
        class: "tw-max-w-full tw-flex tw-flex-col tw-gap-6",
        onSubmit: _withModifiers(onConfirm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Text, {
              variant: "span",
              textWeight: "400",
              class: "tw-mb-2 tw-inline-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Please select reason of rejection ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_select, {
              variant: "outlined",
              class: "custom_selector",
              modelValue: selectedRejectTypes.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRejectTypes).value = $event)),
              items: typeList.value,
              "item-title": "label",
              "item-value": "value",
              placeholder: "Select of Type",
              rules: [(v) => !!v || 'Type is required'],
              required: "",
              "menu-props": { contentClass: 'custom__text__selector' }
            }, null, 8, ["modelValue", "items", "rules"]),
            (isCustomReason.value)
              ? (_openBlock(), _createBlock(Text, {
                  key: 0,
                  variant: "span",
                  textWeight: "400",
                  class: "tw-mb-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Please Specify your reason ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (isCustomReason.value)
              ? (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 1,
                  class: "custom_selector",
                  modelValue: customReason.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customReason).value = $event)),
                  rules: [(v) => !!v || 'Custom reason is required'],
                  required: ""
                }, null, 8, ["modelValue", "rules"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Text, {
              variant: "span",
              textWeight: "400",
              class: "tw-mb-2 tw-inline-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Message (optional) ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_textarea, {
              modelValue: message.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
              placeholder: "Message",
              required: "",
              variant: "outlined",
              class: "custom_selector"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_radio_group, {
              class: "tw-flex",
              inline: "",
              modelValue: rejectType.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rejectType).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio, {
                  label: "REJECT ESTIMATE",
                  value: 1
                }),
                _createVNode(_component_v_radio, {
                  label: "REJECT & DELETE CONTRACTOR",
                  value: 2
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Button, {
              variant: "secondary",
              label: "cancel",
              class: "button !tw-w-1/2 md:!tw-w-full",
              onClick: onCancelModal
            }),
            _createVNode(Button, {
              variant: "primary",
              label: "confirm",
              type: "submit",
              class: "button button-orange !tw-w-1/2 md:!tw-w-full"
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["headerTitle"]))
}
}

})